import NotifyPaymentPendingApi from './NotifyPaymentPendingApi';
export default NotifyPaymentPendingApi;
